import { apiSlice } from "../api/apiSlice";

export const teamApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeams: builder.query({
      query: () => "/team",
    }),
    getTeam: builder.query({
      query: (teamName) => `/team?name=${teamName}`,
    }),
  }),
});

export const { useGetTeamsQuery, useGetTeamQuery } = teamApi;
